module.exports = __webpack_public_path__ + "img/icon_lw.028cad14.png";